import { render, staticRenderFns } from "./AccountMyTradeJournals.vue?vue&type=template&id=64383376&scoped=true&"
import script from "./AccountMyTradeJournals.vue?vue&type=script&lang=js&"
export * from "./AccountMyTradeJournals.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyTradeJournals.vue?vue&type=style&index=0&id=64383376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64383376",
  null
  
)

export default component.exports